import { useMutation, useQueryClient } from '@tanstack/react-query';

import { actionItemCommentsKey } from '@pages/ActionItem/services/useActionItemCommentsQuery';

import { actionItemActiveReportKey } from '@services/actionItem/useActionItemActiveReportQuery';
import { actionItemInactiveReportsKey } from '@services/actionItem/useActionItemInactiveReportsQuery';
import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

const saveNewReportFn = (data) => apiClient.post(`${APP_API_URL}save-new-report`, data);

export const useSaveNewReportMutation = ({ actionItemId }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveNewReportFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemActiveReportKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemInactiveReportsKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
    },
  });
};
